import { useState } from "react";
import cls from "./AdminGameCreatePage.module.scss";

import CreateGameForm from "../../../components/admin/game/CreateGameForm";
import { createAdminGame } from "../../../features/game/gameApi";

export default function AdminGameCreatePage() {
  const [created, setCreated] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCreate = async (payload) => {
    setLoading(true);

    try {
      const data = await createAdminGame(payload);
      setCreated(data.game);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={cls.page}>
      <div className={cls.bgGlowPink} />
      <div className={cls.bgGlowBlue} />

      <div className={cls.container}>
        <header className={cls.header}>
          <div className={cls.kicker}>NOTY ADMIN</div>

          <h1 className={cls.title}>Create Game Room</h1>

          <p className={cls.subtitle}>
            Setup a new game inside the Noty Universe system. Configure access,
            rules, and gameplay settings before publishing it to players.
          </p>
        </header>

        <div className={cls.formCard}>
          <CreateGameForm onSubmit={handleCreate} loading={loading} />
        </div>

        {created && (
          <div className={cls.success}>
            <div className={cls.successTitle}>Game Created Successfully</div>

            <div className={cls.successText}>
              <strong>{created.title}</strong> is now available in the system.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
